import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dash',
  standalone: true
})
export class DashPipe implements PipeTransform {
  transform(value: string): string | undefined {
    return value ? `- ${value}` : '';
  }
}
